module.exports = __webpack_public_path__ + "img/all.8f483caa.png";